import React, { useCallback, useRef } from "react";
import { formatDateDisplayEnglish, formatMonthDisplayEnglish } from "../utils/eventDate";
import { openNativeDateInput } from "../utils/openNativeDateInput";

function CalendarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

/**
 * Styled admin date/month field — entire control opens the native picker (not just the icon).
 * @param {"date"|"month"} inputType
 */
export default function AdminDateInput({
  inputType = "date",
  value = "",
  onChange,
  min,
  max,
  disabled = false,
  required = false,
  size = "sm",
  className = "",
  style,
  id,
  name,
  placeholder,
  "aria-label": ariaLabel,
}) {
  const inputRef = useRef(null);
  const isMonth = inputType === "month";
  const displayText = isMonth
    ? formatMonthDisplayEnglish(value)
    : formatDateDisplayEnglish(value);
  const placeholderText = placeholder || (isMonth ? "Select month" : "Select date");

  const openPicker = useCallback(() => {
    if (!disabled) openNativeDateInput(inputRef.current);
  }, [disabled]);

  const sizeClass = size === "sm" ? "admin-date-input--sm" : "";

  return (
    <div
      className={`admin-date-input ${sizeClass}${disabled ? " admin-date-input--disabled" : ""}${className ? ` ${className}` : ""}`}
      style={style}
      onClick={openPicker}
      role="presentation"
    >
      <input
        ref={inputRef}
        type={inputType}
        id={id}
        name={name}
        className="admin-date-input__native"
        value={value || ""}
        min={min}
        max={max}
        disabled={disabled}
        required={required}
        aria-label={ariaLabel || placeholderText}
        onChange={onChange}
        onClick={(e) => {
          e.stopPropagation();
          openPicker();
        }}
        onFocus={openPicker}
      />
      <div className="admin-date-input__face">
        <span
          className={`admin-date-input__text${displayText ? "" : " admin-date-input__text--placeholder"}`}
        >
          {displayText || placeholderText}
        </span>
        <span className="admin-date-input__icon">
          <CalendarIcon />
        </span>
      </div>
    </div>
  );
}
